import React from 'react';
import FakeTable from './FakeTable';
import {genderedAge, pp} from '../utils';

const TeamCard = ({ team, width = "300px" }) => {
  const { players = [], name, rating, wpr, total_rating } = team;

  return (
    <div 
      className="cursor-grab shadow p-2 m-1 bg-white rounded" 
      style={{ width }}
    >
      {name && players.length > 1 && (
        <div className="font-semibold mb-2 text-left">
          {name}
        </div>
      )}
      
      <FakeTable 
        cs="fake-cells" 
        objs={players} 
        tr={pl => (
          <>
            <td style={{ width: "200px" }}>{pl.name}</td>
            <td>{genderedAge(pl)}</td>
            <td style={{ textAlign: 'right' }}>
              {/*{pl.rating || pl.dupr_rating || '-'}*/}
              {pl.wpr}
            </td>
          </>
        )}
      >
        {players.length > 1 && (total_rating || rating || wpr) && (
          <tr>
            <td colSpan={2} className="text-gray-400">Total:</td>
            <td style={{ textAlign: 'right' }} className="text-gray-400">
              {total_rating || rating || wpr}
            </td>
          </tr>
        )}
      </FakeTable>
    </div>
  );
};

export default TeamCard;